import axios from 'axios';
import _ from 'lodash';
import moment from 'moment';

import BaseModel from './BaseModel';
import UserModel from './UserModel';
const BASE = BaseModel.getApiBasePath() + '/api/v1/core/alerts';

export default new class AlertsModel {

  constructor() { }

  get(id) {
    return new Promise((resolve, reject) => {
      this.getAll()
        .then((data) => {
          resolve(_.find(data, { id: id }));
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  getAll(dateFrom = null, dateTo = null) {
    var filter = {
      order: 'timestamp DESC',
      where: {
        and: []
      }
    };
    if (dateFrom && dateTo) {
      filter.where.and.push({ timestamp: { gte: dateFrom } });
      filter.where.and.push({ timestamp: { lte: dateTo } });
    }
    return new Promise((resolve, reject) => {
      axios.get(BASE, {
        params: {
          access_token: UserModel.getAccessToken(),
          filter: filter
        }
      })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  getUnreportedLastMinute() {
    var beforeMinute = moment().subtract(1, 'minutes');
    var filter = {
      order: 'timestamp DESC',
      where: {
        and: [{
          reported: false
        }, {
          timestamp: {
            gte: beforeMinute
          }
        }]
      }
    };
    return new Promise((resolve, reject) => {
      axios.get(BASE, {
        params: {
          access_token: UserModel.getAccessToken(),
          filter: filter
        }
      })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  create(data) {
    return new Promise((resolve, reject) => {
      axios.post(BASE, data, {
        params: {
          access_token: UserModel.getAccessToken()
        }
      })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  remove(id) {
    return new Promise((resolve, reject) => {
      axios.delete(BASE + '/' + id, {
        params: {
          access_token: UserModel.getAccessToken()
        }
      })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }  

}


// WEBPACK FOOTER //
// ./src/components/AlertsModel.js